import { createSelector } from 'reselect';
import { showSelector } from 'selectors/testTarget/offers/addDeliveryPriceToSDD/show/showSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';

const showAddDeliveryPriceToSDDSelector = createSelector(isTestTargetReadySelector, showSelector, (testReady, show) => testReady && show);

export { showAddDeliveryPriceToSDDSelector };
